var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFcTicketing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 0.75H2.5C1.53393 0.75 0.75 1.53393 0.75 2.5V8.89C0.75 9.85607 1.53393 10.64 2.5 10.64C3.51701 10.64 4.346 11.4681 4.346 12.486C4.346 13.5039 3.51793 14.332 2.5 14.332C1.53393 14.332 0.75 15.1159 0.75 16.082V23.475C0.75 24.4411 1.53393 25.225 2.5 25.225C3.51701 25.225 4.346 26.0531 4.346 27.071C4.346 28.0889 3.51793 28.917 2.5 28.917C1.53393 28.917 0.75 29.7009 0.75 30.667V38.06C0.75 39.0261 1.53393 39.81 2.5 39.81C3.51701 39.81 4.346 40.6381 4.346 41.656C4.346 42.6734 3.51747 43.499 2.5 43.499C1.53393 43.499 0.75 44.2829 0.75 45.249V51.639C0.75 52.6051 1.53393 53.389 2.5 53.389H89.5C90.4661 53.389 91.25 52.6051 91.25 51.639V2.5C91.25 1.53393 90.4661 0.75 89.5 0.75ZM4.25 49.889V46.7041C6.34042 45.9779 7.846 43.9889 7.846 41.653C7.846 39.3172 6.34052 37.3272 4.25 36.6018V32.1201C6.34042 31.3939 7.846 29.4049 7.846 27.069C7.846 24.7332 6.34052 22.7432 4.25 22.0178V17.5361C6.34042 16.8099 7.846 14.8209 7.846 12.485C7.846 10.1491 6.34042 8.16014 4.25 7.43392V4.25H18.917V49.889H4.25ZM87.75 49.888H21.417V4.25H87.75V49.888Z",
    fill: "#0088E7",
    stroke: "#0088E7",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcTicketing);
export default __webpack_public_path__ + "static/media/fc-ticketing.5f72a19193b952f6dcd9248a5cde0985.svg";
export { ForwardRef as ReactComponent };